import { render, staticRenderFns } from "./fgsxx.vue?vue&type=template&id=df75b6f2&scoped=true"
import script from "./fgsxx.vue?vue&type=script&lang=js"
export * from "./fgsxx.vue?vue&type=script&lang=js"
import style0 from "./fgsxx.vue?vue&type=style&index=0&id=df75b6f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df75b6f2",
  null
  
)

export default component.exports